import * as deviceUtils from 'detect-mobile-device';
// /**
//  * 获取 UA
//  * @return {string}
//  */
// export declare function getUserAgent(): string;
// /**
//  * 判断是否是手机
//  */
// export declare function isMobile(): boolean;
// /**
//  * 判断是否是 android 设备
//  */
// export declare function isAndroid(): boolean;
// /**
//  * 判断是否 ios 设备
//  */
// export declare function isIOS(): boolean;
// /**
//  * 是否是 微信 设备
//  */
// export declare function isWeiXin(): boolean;
// /**
//  * 判断是否是 mobile 微信
//  */
// export declare function isMWeiXin(): boolean;
// /**
//  * 判断是否是手机qq
//  * @return {boolean}
//  */
// export declare function isMQQ(): boolean;
// /**
//  * 判断是否是手机微博 UA
//  * @return {boolean}
//  */
// export declare function isMWeibo(): boolean;
// /**
//  * 判断是否是江湖 daily App
//  */
// export declare function isJianghuDaily(): boolean;
export default deviceUtils;
